module.exports = __webpack_public_path__ + "static/media/down_icon.367c9865.svg";